import services from 'services';
import {describeError, describeThrow} from 'utils/errors';
import * as normalize from 'utils/normalize';
import {getResponseData} from 'utils/app';
import messages from 'dicts/messages';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getTeams = () =>
	httpJson('get', '/teams', {
		include: 'users,areas',
		isCalendar: true,
		type: 'Sales',
		_limit: 999,
	})
		.catch(e => {
			const errMsgKey = 'Failed to fetch teams';
			throw describeError(intl.formatMessage({id: errMsgKey}), e);
		})
		.then(getResponseData(normalize.team));

export const getLists = (q = {}) =>
	httpJson('get', `/lists`, q)
		.catch(describeThrow(intl.formatMessage({id: messages.contentFetchFailed})))
		.then(getResponseData(normalize.list));
